export default "https://cdn-static.gokick.com/assets/75ac565edfb9d82dbbe43c50f72b37b3535e18ca/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";